import { CrmPageNotificationsProvider } from '../contexts/CrmPageNotificationsContext';
import { PortalProvider } from '../contexts/PortalContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { ReportAppShell } from './layout/ReportAppShell';

export function ReportPortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <CrmPageNotificationsProvider>
            <ReportAppShell />
          </CrmPageNotificationsProvider>
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}
